"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Tooltip = ({ text, customClass, children, dataCy }) => {
    const tooltipCN = (0, classnames_template_literals_1.default)(`
    bg-n-900
    absolute
    rounded
    px-[12px]
    max-w-sm
    text-n-000
    break-word
    ${customClass}
  `);
    return (react_1.default.createElement("div", { className: tooltipCN, "data-cy": dataCy },
        react_1.default.createElement("span", { className: "typography-h-100" }, text || children)));
};
exports.default = Tooltip;
